import React from 'react';
import { motion } from 'framer-motion';
import { SectionLabel, SectionHeading, PrimaryButton, SecondaryButton } from './ui/UI';
const focusAreas = ['Attack-path reasoning', 'Cloud and identity security', 'AI application security', 'Security validation', 'Evidence graphs', 'Remediation verification', 'MSSP workflows', 'Developer-friendly SaaS', 'Making complex security understandable'];
const roles = ['Founding full-stack engineers', 'Security engineers', 'AI systems engineers', 'Security researchers', 'Product designers', 'GTM operators', 'MSSP partnership builders', 'Developer and security community builders'];
export function JoinTeam() {
  return <section id="jobs" className="relative w-full py-32 border-t border-white/5" data-id="element-593">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-594">
        <SectionLabel number="22" label="Join the Team" className="mb-8" data-id="element-595" />

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mb-16" data-id="element-596">
          <div className="lg:col-span-7" data-id="element-597">
            <SectionHeading size="xl" data-id="element-598">Help rebuild Periscan.</SectionHeading>
          </div>
          <div className="lg:col-span-5 lg:pt-4" data-id="element-599">
            <p className="text-lg text-white/60 leading-relaxed" data-id="element-600">
              Every modern company should be able to understand how it could
              actually be compromised, what to fix first, and whether the fix
              worked. Help us build that.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 mb-12" data-id="element-601">
          {/* Focus areas */}
          <div className="lg:col-span-6 rounded-2xl bg-[#070a0e] border border-white/5 p-8" data-id="element-602">
            <p className="font-mono text-xs uppercase tracking-widest text-[#1a8fd4] mb-6" data-id="element-603">
              We especially care about
            </p>
            <div className="space-y-3" data-id="element-604">
              {focusAreas.map((f, i) => <motion.div key={i} initial={{
              opacity: 0,
              x: -5
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.3,
              delay: i * 0.04
            }} className="flex items-center gap-3 py-2 border-b border-white/5 last:border-0" data-id="element-605">
                  <span className="font-mono text-xs text-white/30" data-id="element-606">
                    {String(i + 1).padStart(2, '0')}
                  </span>
                  <span className="text-base text-white/80" data-id="element-607">{f}</span>
                </motion.div>)}
            </div>
          </div>

          {/* Roles */}
          <div className="lg:col-span-6 rounded-2xl bg-gradient-to-br from-[#1a8fd4]/10 to-[#070a0e] border border-[#1a8fd4]/20 p-8" data-id="element-608">
            <p className="font-mono text-xs uppercase tracking-widest text-[#1a8fd4] mb-6" data-id="element-609">
              Open roles
            </p>
            <div className="space-y-3 mb-8" data-id="element-610">
              {roles.map((r, i) => <motion.div key={i} initial={{
              opacity: 0,
              x: -5
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.3,
              delay: i * 0.04
            }} className="flex items-center gap-3 py-2 border-b border-white/5 last:border-0" data-id="element-611">
                  <span className="w-1.5 h-1.5 rounded-full bg-[#1a8fd4]" data-id="element-612" />
                  <span className="text-base text-white" data-id="element-613">{r}</span>
                </motion.div>)}
            </div>
            <p className="text-sm text-white/60 leading-relaxed" data-id="element-614">
              We care less about perfect resumes and more about judgment, speed,
              security intuition, and the ability to turn complexity into
              something customers can actually use.
            </p>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row gap-4" data-id="element-615">
          <PrimaryButton href="mailto:careers@periscan.com" size="lg" data-id="element-616">
            Join the Team
          </PrimaryButton>
          <SecondaryButton href="mailto:careers@periscan.com" size="lg" data-id="element-617">
            Tell Us How You Want to Help
          </SecondaryButton>
        </div>
      </div>
    </section>;
}